import {http} from '../config'

export default class EnderecoService{

    constructor(){
      this._nomeControle = 'endereco';
    }

    ObterMunicipios(uf){
        return http.get(`${this._nomeControle}/Estado/Municipios`, {
            params: {
                uf
            }
        });
    }

    ObterPorCep(cep){
        return http.get(`${this._nomeControle}/obterporcep`, {
            params: {
                cep: cep
            }
        })
    }

}